export default "__VITE_PUBLIC_ASSET__1cede6fc__"